const builtinTypes: string[] = ['image', 'gallery', 'video', 'raw_html']
export default builtinTypes
